// import logo from "./logo.svg";
//import "./App.css";
import React, { useState, useEffect } from "react";
import { StyleSheet, View } from "react-native";
import { theme } from "../theme";
import {
  Grommet,
  Button,
  Header,
  Page,
  PageContent,
  Text,
  Data,
  DataTable,
  DataSearch,
  Toolbar,
  Box,
  Image,
  List,
  Select,
  Keyboard,
  Grid,
  Carousel,
} from "grommet";

import { StatusGoodSmall, Download } from "grommet-icons";

import { useAuth } from "../context";

import {
  getSuggestedAddress,
  getParsedAddress,
  getReport,
  getSwimmingPoolInfo,
  getProfile,
} from "../api";

import {
  PROPERTY_TYPES,
  ACTION_COLOURS,
  CERT_COLOURS,
  SWIMMING_POOL_PROPERTY_TYPES,
} from "../constants";

import {
  Tooltip,
  AnimatedBackground,
  PrintHideBox,
  FrostedGlassBox,
} from "../components";

const AppBar = (props) => (
  <Header
    //width={{ max: '40rem', min:'90%', width:'94%' }}
    background="brand"
    pad={{ left: "medium", right: "small", vertical: "small" }}
    elevation="medium"
    style={{
      borderRadius: "5px",
      border: "1px solid rgba(255, 255, 255, 0.05)",
      background:
        "linear-gradient(180deg, rgba(74, 79, 107, 0.30) 0%, rgba(35, 37, 50, 0.50) 100%)",
      boxShadow: "0px 25px 50px 0px rgba(1, 5, 22, 0.30)",
      backdropFilter: "backdrop-filter: blur(50px)",
    }}
    {...props}
  />
);

const defaultOptions = PROPERTY_TYPES;

const Demo = () => {
  const { isAuthenticated, isLoading, user, login, logout, tokens } = useAuth();

  const [suggestedAddresses, setSuggestedAddresses] = useState([]);
  const [addressInput, setAddressInput] = useState("");
  const [addressSelected, setAddressSelected] = useState("");
  const [addressParsed, setAddressParsed] = useState({});

  const [gnafSelected, setGnafSelected] = useState("");
  const [propertyTypeSelected, setPropertyTypeSelected] = useState("");

  const [selected, setSelected] = useState();
  const [options, setOptions] = useState(defaultOptions);

  const [addressSearchPlaceholder, setAddressSearchPlaceholder] =
    useState("Search Address...");
  const [propertyTypePlaceholder, setPropertyTypePlaceholder] = useState(
    "Select Property Type..."
  );

  const [reportVisibility, setReportVisibility] = useState(false);
  const [isReportLoading, setIsReportLoading] = useState(false);

  const [reportData, setReportData] = useState();
  const [mappedData, setMappedData] = useState();
  const [swimmingPoolData, setSwimmingPoolData] = useState();

  const [hasImages, setHasImages] = useState(false);
  const [imageList, setImageList] = useState([]);

  const [cid, setCid] = useState();
  const [nickname, setNickname] = useState("");

  useEffect(() => {
    if (tokens?.idToken) {
      const getNickname = async () => {
        const res = await getProfile(tokens.idToken);
        setNickname(res?.nickname ?? "");
        console.log(res);
      };
      getNickname();
    }
  }, [isAuthenticated, tokens]);

  useEffect(() => {
    // clear page if new input
    if (addressInput.length > 0) {
      setPropertyTypeSelected("");
      setReportVisibility(false);
      setAddressSelected("");
      setReportData();
      setMappedData();
      setHasImages(false);
      setImageList([]);
    }

    // get address suggestion
    if (addressInput.length && addressInput.length >= 3) {
      document
        ?.getElementById("suggestedAddressSelect")
        ?.setAttribute("style", "z-index:2");
      const getAddresses = async () => {
        const addresses = await getSuggestedAddress(
          tokens?.idToken,
          addressInput
        );
        setSuggestedAddresses(addresses);
      };
      getAddresses();
    } else {
      setSuggestedAddresses([]);
    }
  }, [addressInput]);

  // get parsed address
  useEffect(() => {
    if (gnafSelected.length > 0) {
      const parseAddress = async () => {
        const parsed = await getParsedAddress(tokens?.idToken, gnafSelected);
        setAddressParsed(parsed);
      };
      parseAddress();
    }
  }, [gnafSelected]);

  /* TEST */
  useEffect(() => {
    if (reportData) {
      if (reportData?.cid) {
        setCid(reportData?.cid);
      }
      let dataList = [];
      Object.entries(reportData?.metrics).map((i) => {
        if (typeof i[1] != "string") {
          dataList.push({
            name: i[0],
            results: i[1],
          });
        }
      });
      setMappedData(dataList);

      console.log(reportData);
      setReportVisibility(true);
      setIsReportLoading(false);

      setAddressInput("");
      //setPropertyTypeSelected('');
      setAddressSearchPlaceholder("Search Address...");
      //setAddressSelected('');

      if (
        reportData?.images?.property &&
        (reportData?.images?.property?.length > 0 ||
          reportData?.images?.floor_plan?.length > 0)
      ) {
        setHasImages(true);
        var tempList = [];
        for (let i = 0; i < reportData?.images?.property?.length; i++) {
          tempList.push(reportData?.images?.property[i]?.basePhotoUrl);
        }
        for (let i = 0; i < reportData?.images?.floor_plan?.length; i++) {
          tempList.push(reportData?.images?.floor_plan[i]?.basePhotoUrl);
        }
        setImageList(tempList);
      } else {
        setHasImages(false);
        setImageList([]);
      }
    }
  }, [reportData]);

  // query report
  useEffect(() => {
    if (gnafSelected && propertyTypeSelected && addressParsed) {
      let query = `property_type=${propertyTypeSelected}`;
      for (const [key, value] of Object.entries(addressParsed)) {
        if (value) {
          query += `&${key}=${value}`;
        }
      }
      console.log(query);
      const queryReport = async () => {
        const report = await getReport(tokens?.idToken, query);
        setReportData(report);
      };
      queryReport();
      setIsReportLoading(true);
    }
  }, [propertyTypeSelected, gnafSelected, addressParsed]);

  /* POOL */
  useEffect(() => {
    if (
      addressSelected &&
      gnafSelected &&
      addressParsed &&
      addressParsed?.state &&
      (addressParsed?.state === "NSW" || addressParsed?.state === "QLD") &&
      SWIMMING_POOL_PROPERTY_TYPES.includes(propertyTypeSelected)
    ) {
      let query = `gnaf=${gnafSelected}&address=${addressSelected}&state=${addressParsed.state}`;
      console.log("swimming pool query:", query);
      const queryPool = async () => {
        const report = await getSwimmingPoolInfo(tokens?.idToken, query);
        setSwimmingPoolData(report);
        console.log("swimming pool:", report);
      };
      queryPool();
      console.log("swimming pool propertyTypeSelected:", propertyTypeSelected);
      //setIsLoading(true);
    }
  }, [propertyTypeSelected]);

  useEffect(() => {
    console.log(swimmingPoolData);
  }, [swimmingPoolData]);
  /* POOL */

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      padding: "middle",
    },
  });

  return (
    <Grommet
      zIndex={1}
      theme={theme}
      full
      style={{ background: "rgba(0,0,0,0)" }}
    >
      <Page width={{ min: "365px" }} align="center" flex="grow">
        <AnimatedBackground />
        <AppBar
          width={{ max: "38.5rem", width: "94%" }}
          margin="0.5rem"
          zIndex={2}
        >
          <Text color="white" size="large">
            {"SAIL Traffic Light"}
          </Text>
          <Image
            margin={{ top: "xsmall", right: "small" }}
            height={"30rem"}
            src={""}
          ></Image>
        </AppBar>
        {isAuthenticated ? (
          <PageContent
            alignSelf="center"
            width={{ max: "40rem" }}
            style={{
              padding: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
            zIndex={2}
          >
            <PrintHideBox zIndex={3}>
              <Data data={suggestedAddresses} zIndex={3}>
                <Toolbar flex="grow">
                  <Keyboard
                    onDown={() => {
                      document
                        ?.getElementById("suggestedAddressSelect")
                        .focus();
                    }}
                  >
                    <DataSearch
                      width={"100%"}
                      alignSelf="center"
                      id="addressInput"
                      placeholder={addressSearchPlaceholder}
                      value={addressInput}
                      onChange={(event) => {
                        setAddressInput(event.target.value);
                      }}
                    />
                  </Keyboard>

                  <Select
                    id="propertyTypeSelect"
                    disabled={
                      addressSelected.length <= 0 ||
                      defaultOptions.filter((o) => o.index ?? !o.keywords)
                    }
                    options={options}
                    placeholder={propertyTypePlaceholder}
                    value={propertyTypeSelected}
                    onChange={(event) => {
                      //console.log(event.selected)
                      setPropertyTypeSelected(event.value?.label);
                    }}
                    onSearch={(text) => {
                      // The line below escapes regular expression special characters:
                      // [ \ ^ $ . | ? * + ( )
                      const escapedText = text.replace(
                        /[-\\^$*+?.()|[\]{}]/g,
                        "\\$&"
                      );
                      const exp = new RegExp(escapedText, "i");
                      setOptions(
                        defaultOptions.filter((o) => exp.test(o.keywords))
                      );
                    }}
                    onClose={() => setOptions(defaultOptions)}
                    itemProp=""
                    //autoFocus
                  />
                </Toolbar>
                <List
                  defaultItemProps={{ zIndex: 3 }}
                  zIndex={2}
                  id="suggestedAddressSelect"
                  border={true}
                  onClickItem={(event) => {
                    //document.getElementById('propertyTypeSelect').focus();
                    if (event?.item?.address) {
                      setSelected(
                        selected === event.index ? undefined : event.index
                      );

                      setAddressSelected(event.item.address);
                      setAddressSearchPlaceholder(event.item.address);

                      setGnafSelected(event.item.id);

                      setAddressInput("");

                      document?.getElementById("propertyTypeSelect").click();
                    }
                  }}
                />
              </Data>
            </PrintHideBox>
            {isReportLoading && <p style={{ zIndex: 0 }}>Loading...</p>}
            {reportVisibility && !isReportLoading && (
              <Box>
                <Box margin={{ top: "0.5rem" }}></Box>

                <FrostedGlassBox>
                  <div class="container">
                    <Box>
                      <Text
                        size="large"
                        margin={{
                          top: "small",
                          bottom: "xsmall",
                          left: "1rem",
                        }}
                      >
                        {addressSelected}
                      </Text>
                    </Box>
                    <View
                      flex="shrink"
                      align="start"
                      style={[
                        styles.container,
                        {
                          // Try setting `flexDirection` to `"row"`.
                          flexDirection: "row",
                        },
                      ]}
                    >
                      <View style={{ flex: 1 }}>
                        <Text
                          margin={"0.5rem 1rem 0 1rem"}
                          style={{
                            color:
                              ACTION_COLOURS[
                                reportData?.metrics["Final Result"]
                              ],
                          }}
                        >
                          {reportData?.metrics["Final Result"]}
                        </Text>
                      </View>
                      <View style={{ flex: 7 }}></View>
                      <View>
                        <Text
                          margin={"0.5rem 1rem 0 0"}
                        >{`Max LVR : ${Math.floor(reportData?.max_lvr * 100).toFixed(0)}%`}</Text>
                      </View>
                    </View>
                    <Box margin={{ top: "0.5rem" }}></Box>
                  </div>
                </FrostedGlassBox>
                <Box margin={{ top: "0.5rem" }}></Box>
                <FrostedGlassBox>
                  <div class="container">
                    <Box
                      height={{
                        height: `${window?.innerWidth ? window?.innerWidth * 0.6333 : 200}px`,
                        max: "25.332rem",
                      }}
                      width={{ max: "40rem", width: "100%" }}
                      overflow="hidden"
                    >
                      {hasImages ? (
                        <Carousel
                          fill
                          wrap
                          style={{ animation: "100ms" }}
                          controls="arrows"
                        >
                          {imageList.map((i) => {
                            return <Image fit="cover" src={i} />;
                          })}
                        </Carousel>
                      ) : (
                        <Text alignSelf="center" margin={"auto"}>
                          No image is available for this property.
                        </Text>
                      )}
                    </Box>
                  </div>
                </FrostedGlassBox>
                <Box margin={{ top: "0.49rem" }}></Box>
                <FrostedGlassBox>
                  <div class="container">
                    <Box
                      margin={{ top: "1rem", left: "1.5rem", bottom: "1rem" }}
                    >
                      <View
                        flex="shrink"
                        align="start"
                        style={[
                          styles.container,
                          {
                            // Try setting `flexDirection` to `"row"`.
                            flexDirection: "row",
                          },
                        ]}
                      >
                        <View style={{ flex: 2 }}>
                          <Box margin={{ top: "0" }}>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="large"
                            >{`Property Type`}</Text>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="medium"
                            >{`${propertyTypeSelected}`}</Text>
                          </Box>
                        </View>
                        <View style={{ flex: 2 }}>
                          <Box margin={{ top: "0rem" }}>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="large"
                            >{`Land Titling`}</Text>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="medium"
                            >{`${reportData?.land_titling ? reportData?.land_titling : "-"}`}</Text>
                          </Box>
                        </View>
                      </View>
                      <Box margin={{ top: "1rem" }}>
                        <Text
                          flex="shrink"
                          margin={{ vertical: "auto" }}
                          size="large"
                        >{`Layout`}</Text>
                        <View
                          flex="shrink"
                          align="start"
                          style={[
                            styles.container,
                            {
                              // Try setting `flexDirection` to `"row"`.
                              flexDirection: "row",
                            },
                          ]}
                        >
                          <View style={{ flex: 2 }}>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="xsmall"
                            >
                              Bedrooms
                            </Text>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="small"
                            >{`${reportData?.property_summary?.bedrooms ? reportData?.property_summary?.bedrooms : "-"}`}</Text>
                          </View>
                          <View style={{ flex: 2 }}>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="xsmall"
                            >
                              Bathrooms
                            </Text>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="small"
                            >{`${reportData?.property_summary?.bathrooms ? reportData?.property_summary?.bathrooms : "-"}`}</Text>
                          </View>
                          <View style={{ flex: 2 }}>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="xsmall"
                            >
                              Carparks
                            </Text>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="small"
                            >{`${reportData?.property_summary?.carparks ? reportData?.property_summary?.carparks : "-"}`}</Text>
                          </View>
                          <View style={{ flex: 2.25 }}>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="xsmall"
                            >
                              Land Area
                            </Text>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="small"
                            >
                              {reportData?.property_summary?.land_area
                                ? parseInt(
                                    reportData?.property_summary?.land_area
                                  ) + ` ㎡`
                                : "-"}
                            </Text>
                          </View>
                          <View style={{ flex: 2 }}>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="xsmall"
                            >
                              Floor Area
                            </Text>
                            <Text
                              flex="shrink"
                              margin={{ vertical: "auto" }}
                              size="small"
                            >
                              {reportData?.property_summary?.floor_area
                                ? parseInt(
                                    reportData?.property_summary?.floor_area
                                  ) + ` ㎡`
                                : "-"}
                            </Text>
                          </View>
                        </View>
                      </Box>
                    </Box>
                  </div>
                </FrostedGlassBox>

                <Box margin={{ top: "0.5rem" }}></Box>
                <FrostedGlassBox>
                  <div class="container">
                    <Box
                      margin={{ top: "1rem", left: "1.5rem", bottom: "1rem" }}
                    >
                      <Box margin={{ top: "0rem" }}>
                        <Text
                          flex="shrink"
                          margin={{ vertical: "auto" }}
                          size="large"
                        >{`Metrics`}</Text>
                        <DataTable
                          pad={"xxsmall"}
                          columns={[
                            {
                              property: "name",
                              header: "Category",

                              size: "1/3",
                            },
                            {
                              primary: true,
                              property: "results",
                              header: "Results",
                              render: (datum) => {
                                return (
                                  <Box>
                                    <ul style={{ margin: "0", padding: "0" }}>
                                      {datum?.results?.length > 0 ? (
                                        datum?.results?.map((i) => (
                                          <StatusGoodSmall
                                            color={ACTION_COLOURS[i]}
                                          />
                                        ))
                                      ) : (
                                        <StatusGoodSmall
                                          color={"rgba(0,0,0,0)"}
                                        />
                                      )}
                                    </ul>
                                  </Box>
                                );
                              },
                            },
                          ]}
                          data={mappedData}
                        />
                      </Box>
                    </Box>
                  </div>
                </FrostedGlassBox>

                {addressParsed?.state === "NSW" &&
                  SWIMMING_POOL_PROPERTY_TYPES.includes(propertyTypeSelected) &&
                  typeof swimmingPoolData === "object" &&
                  Object.keys(swimmingPoolData).length > 0 && (
                    <>
                      <Box margin={{ top: "0.5rem" }}></Box>
                      <FrostedGlassBox>
                        <div class="container">
                          <Box
                            margin={{
                              top: "1rem",
                              left: "1.5rem",
                              bottom: "1rem",
                            }}
                          >
                            <Text
                              margin={{ vertical: "auto" }}
                              size="large"
                            >{`Swimming Pool Registration`}</Text>

                            <Box margin={{ top: "0.3rem" }}></Box>
                            <Grid
                              rows={["100%"]}
                              columns={["36%", "3%", "5%"]}
                              gap="small"
                              areas={[
                                { name: "label", start: [0, 0], end: [0, 0] },
                                { name: "status", start: [1, 0], end: [1, 0] },
                                { name: "link", start: [2, 0], end: [2, 0] },
                              ]}
                            >
                              <Box gridArea="label">
                                <Text weight="lighter">
                                  Registration Certificate
                                </Text>
                              </Box>
                              <Box gridArea="status">
                                <Tooltip
                                  contents={
                                    swimmingPoolData?.registration_certificate
                                  }
                                  node={
                                    <StatusGoodSmall
                                      color={
                                        CERT_COLOURS[
                                          swimmingPoolData
                                            ?.registration_certificate
                                        ]
                                      }
                                    />
                                  }
                                ></Tooltip>
                              </Box>
                              {swimmingPoolData?.registration_certificate !==
                                "Missing" && (
                                <Box gridArea="link">
                                  <Tooltip
                                    contents={"Download"}
                                    node={
                                      <Download
                                        size="1.2rem"
                                        onClick={() => {
                                          window.open(
                                            swimmingPoolData?.registration_certificate_url,
                                            "_blank"
                                          );
                                        }}
                                        color={"white"}
                                      />
                                    }
                                  ></Tooltip>
                                </Box>
                              )}
                            </Grid>

                            <Box margin={{ top: "0.2rem" }}></Box>
                            <Grid
                              rows={["100%"]}
                              columns={["36%", "3%", "5%"]}
                              gap="small"
                              areas={[
                                { name: "label", start: [0, 0], end: [0, 0] },
                                { name: "status", start: [1, 0], end: [1, 0] },
                                { name: "link", start: [2, 0], end: [2, 0] },
                              ]}
                            >
                              <Box gridArea="label">
                                <Text size="normal" weight={"lighter"}>
                                  Compliance Certificate
                                </Text>
                              </Box>
                              <Box gridArea="status">
                                <Tooltip
                                  contents={
                                    swimmingPoolData?.non_compliance_certificate ??
                                    swimmingPoolData?.compliance_certificate
                                  }
                                  node={
                                    <StatusGoodSmall
                                      color={
                                        CERT_COLOURS[
                                          swimmingPoolData
                                            ?.compliance_certificate
                                        ]
                                      }
                                    />
                                  }
                                ></Tooltip>
                              </Box>
                              {(swimmingPoolData?.compliance_certificate !==
                                "Missing" ||
                                (swimmingPoolData?.non_compliance_certificate_url &&
                                  swimmingPoolData?.non_compliance_certificate_url !==
                                    "")) && (
                                <Box gridArea="link">
                                  <Tooltip
                                    contents={"Download"}
                                    node={
                                      <Download
                                        size="1.2rem"
                                        onClick={() => {
                                          window.open(
                                            swimmingPoolData?.compliance_certificate_url !==
                                              ""
                                              ? swimmingPoolData?.compliance_certificate_url
                                              : swimmingPoolData?.non_compliance_certificate_url,
                                            "_blank"
                                          );
                                        }}
                                        color={"white"}
                                      />
                                    }
                                  ></Tooltip>
                                </Box>
                              )}
                            </Grid>
                          </Box>
                        </div>
                      </FrostedGlassBox>
                    </>
                  )}
              </Box>
            )}
          </PageContent>
        ) : (
          !isLoading && (
            <PageContent
              alignSelf="center"
              width={{ max: "53rem" }}
              style={{
                padding: "1rem",
                display: "flex",
                flexDirection: "column",
              }}
              zIndex={2}
            >
              <Box width={"15rem"} alignSelf="center">
                <Button
                  alignSelf="center"
                  margin={{ top: "1rem" }}
                  label="Sign in"
                  onClick={() => login()}
                  style={{ fontWeight: "lighter" }}
                />
              </Box>
            </PageContent>
          )
        )}
      </Page>
    </Grommet>
  );
};

export { Demo };
